import {
  createDevelopmentFlags,
  type FeatureFlagConfigMap,
  type FeatureFlagsOptions,
} from '@cosmos/feature-flags';

import { releaseFlags } from './release-features';

export type CustomerPortalFeatureTag =
  | 'action-bar'
  | 'ai'
  | 'collections'
  | 'distributors'
  | 'events'
  | 'infra'
  | 'media-manager'
  | 'navigation'
  | 'orders'
  | 'pdp'
  | 'pim'
  | 'presentations'
  | 'product-search'
  | 'settings'
  | 'sharing'
  | 'vs'
  | 'websites';

// Feature flag metadata with enabled state
export const featureFlagMetadata = {
  portal_ssr: {
    enabled: false,
    description: 'Enable server-side rendering for customer portal',
    usedIn: 'apps/customer-portal',
    owner: '@asi/peryton',
    tags: ['infra'],
  },
  standalone_presentation_products_like_dislike: {
    enabled: true,
    description:
      'Enable Like/Dislike functionality on standalone presentations (product cards, action bar, product details page and the "Liked products" tab). Non-standalone presentations are not affected',
    usedIn:
      'libs/customer-portal/presentations/feature-products, libs/customer-portal/presentations/ui-product-detail, libs/customer-portal/presentations/util-product-actions',
    owner: '@asi/phoenix',
    tags: ['presentations'],
  },
} satisfies FeatureFlagConfigMap<CustomerPortalFeatureTag>;

// Map flags to their enabled state
const developmentFlags =
  /*@__PURE__*/ createDevelopmentFlags(featureFlagMetadata);

export const featureFlagsToolbarOptions: FeatureFlagsOptions = {
  development: {
    title: 'Development',
    color: '#c23f22',
    flags: developmentFlags,
  },
  release: {
    title: 'Release',
    color: '#09755d',
    flags: releaseFlags satisfies typeof developmentFlags,
  },
};
